import Layout from '../modules/Layout';
import HowItWorks from '../modules/HowItWorks';
import { ArticlePage } from './article';
import { CustomNextPage } from '../lib/types';
import { howItWorksQuery } from '../core-types';
import { FEATURE_BLOCKS_FRAGMENT } from '../lib/core/fragments/featureBlocks';
import { gql } from '@apollo/client';
import { bootstrap } from '../lib/bootstrap';
import { useQuery } from '@apollo/client';

const HOW_IT_WORKS_PAGE_QUERY = gql`
  ${FEATURE_BLOCKS_FRAGMENT}
  query howItWorksQuery {
    system {
      id
      cityName
    }
    howItWorksPage: sanityHowItWorksPage {
      title
      heading
      description
      file
      featureBlocks {
        ...FeatureBlocks
      }
    }
  }
`;

const HowItWorksPage: CustomNextPage<{
  statusCode?: number;
  useArticle: boolean;
}> = props => {
  const { url, statusCode, useArticle } = props;
  const { loading, data } = useQuery<howItWorksQuery>(HOW_IT_WORKS_PAGE_QUERY);
  if (useArticle) {
    return (
      <ArticlePage
        statusCode={statusCode}
        url={url}
        systemConfig={props.systemConfig}
      />
    );
  }

  const title = data && data.howItWorksPage && data.howItWorksPage.title;

  return (
    <Layout
      statusCode={statusCode}
      title={title}
      url={url}
      loading={loading}
      contentProps={{
        // Override Content defaultProps
        py: 0,
        mx: 0,
        mb: 0
      }}
      render={({ appContent }) => {
        if (!data) {
          return null;
        }
        return <HowItWorks data={data} appContent={appContent} />;
      }}
    />
  );
};

HowItWorksPage.getInitialProps = async ctx => {
  const howItWorksPageResult = await ctx.apolloClient.query<howItWorksQuery>({
    query: HOW_IT_WORKS_PAGE_QUERY
  });
  let statusCode;
  let useArticle = false;
  const howItWorksPage =
    howItWorksPageResult.data && howItWorksPageResult.data.howItWorksPage;
  if (!howItWorksPage || (howItWorksPage && !howItWorksPage.title)) {
    const articlePageGIP =
      ArticlePage.getInitialProps && (await ArticlePage.getInitialProps(ctx));

    if (articlePageGIP) {
      statusCode = articlePageGIP.statusCode;
    }

    if (statusCode === 404) {
      if (ctx.res) {
        // eslint-disable-next-line require-atomic-updates
        ctx.res.statusCode = statusCode;
      }
    } else {
      useArticle = true;
    }
  }

  return {
    useArticle,
    statusCode
  };
};

export default bootstrap(HowItWorksPage);
